// extracted by mini-css-extract-plugin
module.exports = {"root":"EditItem_root__31TqR"};